import { Outlet, Navigate } from "react-router-dom";

export const PrivateRoute = () => {

    let isAuth:any = localStorage.getItem('user')
    return(
        isAuth ? <Outlet/> : <Navigate to="/"/>
    )
}